module.exports = __webpack_public_path__ + "static/media/car-icon.3d959f78.png";